import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import IconButton from 'material-ui/IconButton';
import DeleteIcon from 'material-ui-icons/Delete';

import axios from 'axios';

import { openOverlay, ommitItem } from './actions';

class Omit extends Component {



  render(){
    const { classes, theme, location, data } = this.props;

    const result = this.props.priority_change_array.find( item => item.access_id === this.props.data["access id"] );
    const result_ommitted = this.props.items_ommitted.find( item => item.access_id === this.props.data["access id"] );


    if (result){
      if (result.new_priority != 5){
        return(
          <div className={classes.root}>
            <IconButton className={classes.button} aria-label="Delete" onClick={() => this.props.openOverlay(data)}>
              <DeleteIcon />
            </IconButton>
          </div>
        );
      } else {
        return (<div></div>);
      }
    } else {
      if (data["Dsc_ID"] == 5 || result_ommitted) {
        return (<div></div>);
      } else {
        return(
          <div className={classes.root}>
            <IconButton className={classes.button} aria-label="Delete" onClick={() => this.props.openOverlay(data)}>
              <DeleteIcon />
            </IconButton>
          </div>
        );
      }
    }
/*
    if (result){

      if (result.new_priority != 5){
        return(
          <div className={classes.root}>
            <IconButton className={classes.button} aria-label="Delete" onClick={() => this.props.openOverlay(data)}>
              <DeleteIcon />
            </IconButton>
          </div>
        );
      } else {
        return (<div></div>);
      }
    } else {
      if (data["Dsc_ID"] == 5 || result_ommitted) {
        return (<div></div>);
      } else {
        return(
          <div className={classes.root}>
            <IconButton className={classes.button} aria-label="Delete" onClick={() => this.props.openOverlay(data)}>
              <DeleteIcon />
            </IconButton>
          </div>
        );
      }
    }*/
  }
}

function mapStateToProps(state) {
    return {
        actions: state.dashboard.actions,
        items_ommitted: state.item_ommitted,
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
        counter: state.counter,
        router: state.router,
        rrd_data: state.rrd_data,
        priority: state.dashboard.priority,
        priority_change_array: state.prioritychangeid
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
      openOverlay: openOverlay,
      ommitItem: ommitItem,
    }, dispatch);
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, matchDispatchToProps)(Omit)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/Item/components/Omit/index.js